module.exports = __webpack_public_path__ + "static/media/ngc_footer.3b94a48b.png";